<script>
import isMobile from 'ismobilejs'

export default {
  name: 'PartTabWrapper',
  data() {
    return {
      tabs: [],
    }
  },
  computed: {
    isMobile() {
      return !isMobile().any
    },
  },
  methods: {
    selectPart(title) {
      this.$emit('set-tab', title)
    },
  },
  created() {
    this.tabs = this.$children
  },
}
</script>

<template>
  <fragment>
    <div class="avatar-part" v-dragscroll="isMobile">
      <ul class="list-item">
        <template v-for="(tab, idx) of tabs">
          <li
            :key="`tab${idx}`"
            :class="[tab.data.parentClass, { active: tab.selected }]"
            @click="selectPart(tab.data.id)"
            v-if="!tab.data.hide"
          >
            <span>{{ tab.title }}</span>
          </li>
        </template>
      </ul>
    </div>
    <div class="panel">
      <slot name="content" />
    </div>
    <div class="button">
      <slot name="btn" />
    </div>
  </fragment>
</template>

<style lang="scss" scoped>
@import 'part-tab-wrapper.scss';
</style>
